import { Hex, parseAbi, PublicClient } from "viem";
import { SessionKeyOnChainData } from "../types";
import { sessionKeyValidatorAbi } from "../common";

export const getOnchainSessionKeyData = async (etherspotWalletAddress: string, publicClient: PublicClient, sesssionKeyValidatorAddress: string, sessionKey: string): Promise<SessionKeyOnChainData> => {

    const data = await publicClient.simulateContract({
        account: etherspotWalletAddress as Hex,
        address: sesssionKeyValidatorAddress as Hex,
        abi: parseAbi(sessionKeyValidatorAbi),
        functionName: 'sessionData',
        args: [sessionKey, etherspotWalletAddress]
    });

    if (!data.result || data.result == null) {
        throw new Error('Session data not found');
    }

    const { token, funcSelector, spendingLimit, validAfter, validUntil, live } = data.result;

    return {
        account: etherspotWalletAddress,
        token,
        funcSelector,
        spendingLimit,
        validAfter,
        validUntil,
        live
    }
}

export const isSessionKeyLiveOnChain = async (etherspotWalletAddress: string,
    publicClient: PublicClient, sesssionKeyValidatorAddress: string,
    sessionKey: string): Promise<boolean> => {

    const data = await publicClient.simulateContract({
        account: etherspotWalletAddress as Hex,
        address: sesssionKeyValidatorAddress as Hex,
        abi: parseAbi(sessionKeyValidatorAbi),
        functionName: 'isSessionKeyLive',
        args: [sessionKey]
    });

    if (!data.result || data.result == null) {
        throw new Error('Session data not found');
    }

    return data.result;
}